<template>
    <div class="photo-upload">
        <h1 style="font-weight: bold;">上传到</h1>
        <div class="content">
            <div class="top">
                <!-- :model="editCategory" -->
                <el-form :inline="true"  class="demo-form-inline">
                    <el-form-item label="文件路径">
                        <el-cascader
                            class="cascader"
                            v-model="selectedCategoryKeys"
                            :options="category"
                            :props="props"
                            :placeholder="default_folder_category.label"
                            @change="parentCateChanged"
                            >
                        </el-cascader>
                     </el-form-item>
                </el-form>
                
                <el-button type="text" @click="create_new_filefolder">新建文件夹</el-button>
            </div>

            <div class="bottom">
                <el-upload
                    class="upload-demo"
                    drag
                    :action="`${baseURL}/admin/upload/upload`"
                    multiple
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :http-request="customUpload"
                    :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </div>
            
            <div class="upload-list">
                <photos-upload-list :uploaders = "uploaders"></photos-upload-list>
            </div>
        </div>


        <el-dialog
            class="new-folder-dialog"
            title="新建文件夹"
            :visible.sync="new_filefoler_dialog_show"
            width="35%"
            :before-close="handleDialogClose"
            append-to-body>
            <!-- :model="editLanguage" -->
            <el-form :inline="true"  class="demo-form-inline">
                <el-form-item label="文件夹名">
                    <el-input v-model="newCategoryName" placeholder="输入文件夹名"></el-input>
                </el-form-item>
               
                <el-form-item label="选择父文件夹">
                    <el-cascader
                        class="cascader"
                        v-model="selectedNewCategoryKeys"
                        :options="category"
                        :props="props"
                        :placeholder="default_folder_category.label"
                        @change="parentCateChanged">
                    </el-cascader>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="new_filefoler_dialog_show = false">取 消</el-button>
                <el-button type="primary" @click="new_filefoler_submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
import { all_filecategory_list, eidt_filecategory,baseURL, photo_chunk_upload } from '../../api/api';
import { Uploader } from '../../uploader/upload';

import PhotosUploadList from './PhotosUploadList.vue';

    export default {
      name: 'photo-upload',
      components:{
        PhotosUploadList
      },
      props: {
        value: {
          type: Boolean,
          default: false,
        },
        disabled: {
          type: Boolean,
          default: false,
        },
      },
      data() {
        return {
          default_folder_category:{
            value:0,
            id:0,
            name:'默认文件夹',
            label:'默认文件夹'
          },
          new_filefoler_dialog_show:false,
          category:[],
          selectedCategoryKeys:[0],
          selectedNewCategoryKeys:[0],
          newCategoryName:'',
          props: {
            checkStrictly: true, // 允许父节点单独选中
          },
          baseURL,
          uploaders:[]
        };
      },
      mounted(){
        this.get_all_file_folders()
      },
      computed: {
        
      },
      methods: {
        create_new_filefolder(){
            this.new_filefoler_dialog_show = true
        },
        parentCateChanged(e,v){
            console.log('parentCateChanged',e,v)
            // md5()
        },
        handleDialogClose(){
            this.new_filefoler_dialog_show = false;
            this.newCategoryName = ''
        },
        new_filefoler_submit(){
            if(!this.newCategoryName.length){
                this.$message({
                    message:'需填写文件夹名',
                    showClose:true,
                    type:'error'
                })
                return;
            }
            this.new_filefoler_dialog_show = false;
            var pid = this.default_folder_category.id;
            if(this.selectedNewCategoryKeys.length){
                pid = this.selectedNewCategoryKeys[this.selectedNewCategoryKeys.length-1]
            }
            eidt_filecategory({pid,name:this.newCategoryName})
            .then(res=>{
                this.$message({
                    message:'文件夹创建成功',
                    showClose:true,
                    type:'success'
                })
             
                this.selectedCategoryKeys = [...this.selectedNewCategoryKeys,res.id];
            
                this.get_all_file_folders()
            })
            .catch(err=>{
                this.$message({
                    message:err,
                    showClose:true,
                    type:'error'
                })
            })
        },
        get_all_file_folders(){
            all_filecategory_list()
            .then(res=>{
                if(!res.tree.length){
                    res.tree = []
                }
                 res.tree.unshift(this.default_folder_category);
                 this.category = res.tree
                this.categorysKeyAddForEach(this.category)
            })
            
        },
        categorysKeyAddForEach(arr){
            arr.forEach(item=>{
                item.value = item.id;
                item.label = item.name;
                if(item.children && item.children.length){
                    this.categorysKeyAddForEach(item.children)
                }else if(item.children){
                    Reflect.deleteProperty(item, 'children');
                }
            })
         },
         // 文件上传前的钩子
        beforeUpload(file) {
            console.log('文件上传前:', file);
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isVideo = file.type == 'video/mp4'
            if(!isJPG && !isVideo){
                this.$message.error('只能传jpg,png格式的图片或者mp4格式的视频')
                return false
            }
            return true;
        },

        // 自定义上传逻辑
        async customUpload(options) {
            
            const uploader = new Uploader(options,this.selectedCategoryKeys[this.selectedCategoryKeys.length - 1]);
        
            this.uploaders.unshift(uploader);
            
        },

        // 文件超出限制时的钩子
        handleExceed() {
        this.$message.warning('只能上传一个文件');
        },
      }
    };
  </script>
  
<style lang="less">
.photo-upload{
    padding: 20px;
    .content{
        .top{
            display: flex;
            // align-items: center;
            .demo-form-inline{
               margin-top: 20px;
            }
        }
        // .bottom{
        //     border-bottom: solid 1px red;
        // }
    }
}

// .new-folder-dialog{
//     z-index: 99999999;
// }
</style>
  